import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function UploadProfilePictureModal({
  id,
  cancelModal,
  fetchData,
}) {

  //styled
  const [selectedFile, setSelectedFile] = useState(null);
  const { user } = useAuthContext();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [isLoading, setItLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    if (file) {
      setPreviewUrl(URL.createObjectURL(file)); // Create a preview URL for the selected image
    } else {
      setPreviewUrl(null);
    }
  };
  const fileUploadHandler = async (e) => {
    setItLoading(true);
    e.preventDefault(); // Prevent default form submission behavior
    if (!selectedFile) return; // Don't proceed if no file selected

    const formData = new FormData();
    formData.append("image", selectedFile);

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/ClubProfileImage/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status == 200) {
        //    fetchData()
        setUploadSuccess(true);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setItLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    if (uploadSuccess) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Image Uploaded</p></div> 



           <p>Profile image has been successfully updated.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  fetchData();
                  cancelModal();
                }}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div >
              {" "}
              {/* Attach submit handler */}
              <div className="send-modal-content">
              <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Upload Profile Image</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>

               
                <div>
                  <input type="file" onChange={handleFileChange} />
                  <button onClick={fileUploadHandler} className="saveChanges-button">
                    Upload</button>{" "}
                  {/* Ensure button type is "submit" */}
                </div>
                {previewUrl && (
                  <img
                    src={previewUrl}
                    alt="Image Preview"
                    style={{ width: "100px", height: "100px" }}
                  />
                )}
              </div>
              <div className="send-modal-footer">
              <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>

              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}
